module.exports = __webpack_public_path__ + "static/media/005-feather-blue.351ec212.svg";